export default {
    ENCAMINHAMENTO_INTERNO_NO_DIA: 1,
    ENCAMINHAMENTO_PARA_SERVICO_ESPECIALIZADO: 2,
    ENCAMINHAMENTO_PARA_CAPS: 3,
    ENCAMINHAMENTO_PARA_INTERNACAO_HOSPITALAR: 4,
    ENCAMINHAMENTO_PARA_URGENCIA: 5,
    ENCAMINHAMENTO_PARA_SERVICO_DE_ATENCAO_DOMICILIAR: 6,
    ENCAMINHAMENTO_INTERSETORIAL: 7,
}